export const TEMPO_ADDON_KEY = 'io.tempo.jira';
